import React from "react";
import "./loader.scss";
import loading from "../../assets/images/loading.gif";
function Loader(props) {
  return <span className="content-loader"></span>;
}

export default Loader;
